import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import Border, { BorderSizeOption } from "~/components/elements/Border";
import { Heading, HeadingSizeOption } from "~/components/elements/typography/Heading";
import ArticlesPreviewsSection from "../flexible/Resources/ArticlesPreviewsSection";

const SearchResults = ({ results, query }) => {
	return (
		<section className="bg-white pt-36 text-black md:pt-[222px]">
			<div className="container">
				<div className="flex items-center">
					<div className="w-full md:w-1/2">
						<Border size={BorderSizeOption.Hero}>
							<div className="py-12">
								<Heading text="Search Results" size={HeadingSizeOption.h1Large} />

								<div className="mt-[19px] text-[24px] leading-[25px]">
									<div className="max-w-[433px]">
										We found <span className="font-bold text-purple"> {results?.length} Results </span> matching the search term{" "}
										<span className="text-purple">‘{query}’ </span>
									</div>
								</div>
							</div>
						</Border>
					</div>
					<div className="w-full md:w-1/2">
						<StaticImage src={"../../assets/images/search-results.jpg"} alt="search hero" />
					</div>
				</div>
			</div>
			<div className="bg-dark-purple pb-20 pt-20 lg:pb-[135px] lg:pt-[156px]">
				<div className="container">
					<ArticlesPreviewsSection allPosts noLimit posts={results} />{" "}
				</div>
			</div>
		</section>
	);
};

export default SearchResults;
